/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'Artifact'>;
const hooks = useModelQueries(schema, 'Artifact');

export const useAggregateArtifact: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountArtifact: Hooks['useCount'] = hooks.useCount;
export const useCreateArtifact: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyArtifact: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnArtifact: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteArtifact: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyArtifact: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsArtifact: Hooks['useExists'] = hooks.useExists;
export const useFindFirstArtifact: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyArtifact: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueArtifact: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByArtifact: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyArtifact: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateArtifact: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountArtifact: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstArtifact: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyArtifact: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueArtifact: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByArtifact: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyArtifact: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateArtifact: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyArtifact: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnArtifact: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertArtifact: Hooks['useUpsert'] = hooks.useUpsert;
